<template>
  <div class="lp-adm-drop-input-container">
    <div class="drop-input-select-wrapper"
         @click.capture="isOpen=true"
         :style="wrapperStyle">

      <!-- 선택된 이미지 들어올 자리 -->
      <img v-if="imgPath(selectedLabel)" :src="imgPath(selectedLabel)" style="width: 85%" :style="imageStyle">
      <div v-else style="height:20px;width:212px"></div>
      <!--<div>{{ selectedLabel }}</div>-->
      <div class="drop-button">
        <i v-if="!isOpen"
           @click.stop.prevent="isOpen=true"
           class="material-icons drop-input-arrow-icon">keyboard_arrow_down</i>
        <i v-if="isOpen"
           @click.stop.prevent="isOpen=false"
           class="material-icons drop-input-arrow-icon">keyboard_arrow_up</i>
      </div>
    </div>

    <div v-if="isOpen && list.length!==0"
         class="drop-input-list"
         :style="listStyle"
         @mouseover.stop.prevent="trigger=false"
         @mouseleave.stop.prevent="trigger=true">
      <div class="drop-input-item"
           v-for="(item,idx) in list"
           :key="'sort-list'+idx">
        <img @click.stop.prevent="clickTargetItem(item)"
             :src="imgPath(item[value_name])"
             :style="imageStyle"
             class="lp-drop-item-image">
      </div>
    </div>

    <!-- 아웃 사이드 클릭시 닫기 -->
    <div v-if="isOpen" class="lp-outsider-layout" @click="isOpen=false"></div>

  </div>
</template>

<script>
  export default {
    props: ['data', 'placeholder', 'width', 'listAlign', 'selectVal', 'value_name'],
    data() {
      return {
        trigger: false,
        isOpen: false,
        selectedLabel: '',
        list: []
      }
    },
    created() {
      this.list = this.data;
      this.selectedLabel = this.selectVal;
    },
    computed: {
      wrapperStyle() {
        let style = {};
        if (this.width !== undefined) {
          style.width = this.width;
        }
        return style;
      },
      listStyle() {
        let style = {};
        if (this.width !== undefined) {
          style.width = this.width;
        }
        if (this.listAlign !== undefined) {
          style.textAlign = this.listAlign;
        }
        return style;
      },
      imageStyle() {
        return 'width: 212px; height: 27px; background-repeat: no-repeat;';
      }
    },
    watch: {
      data(n) {
        this.list = n;
      },
      selectVal(n) {
        this.selectedLabel = this.selectVal;
      }
    },
    methods: {
      clickTargetItem(item) {
        this.isOpen = false;
        this.selectedLabel = item[this.value_name];
        this.$emit('onSelect', item);
      },
      onBlur() {
        if (this.trigger) {
          this.isOpen = false;
        }
      },
      imgPath(name) {
        return `https://launchpack-storage.s3.amazonaws.com/media/admin/inputlist/${name}.png`;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

  .lp-drop-item-image
    height 27px
    background-repeat no-repeat

  .lp-adm-drop-input-container
    position relative

  .drop-input-select-wrapper
    box-shadow: inset 0 1px 2px rgba(10,10,10,0.1);
    //width 240px
    border 1px solid #ccc
    border-radius 3px
    display flex
    align-items center
    background-color white
    height 31.5px

  .drop-input-input
    box-shadow inset 0 1px 2px rgba(10, 10, 10, 0.1)
    width calc(100% - 17px)
    border none
    border-right 1px solid #ccc
    font-size .9rem
    padding 7px 12px
    padding-right 0
    color #333
    outline none

  .drop-button
    text-align center
    height 1rem

  .drop-input-arrow-icon
    font-size 1.2rem
    cursor pointer

  .drop-input-list
    list-style none
    margin 0
    padding 0
    background-color #fff
    border 1px solid #ddd
    border-top none
    /*height 192px*/
    max-height: 192px;
    overflow-y auto
    position absolute
    top 32px
    left inherit
    z-index 11
    width 100%

  .drop-input-item
    font-size .9rem
    color #555
    height 34px
    cursor pointer
    margin 8px
    border 1px solid #eee
    padding 2px 0

  // input placeholder style
  // .drop-input-input::-webkit-input-placeholder

  .lp-outsider-layout
    position fixed
    z-index 10
    top 0
    left 0
    right 0
    bottom 0

</style>
